import { RecordRenewalStatus, RecordTypeStatusType } from 'types/graphql'

import Tag, { TagColor } from 'src/components/Tag'

type Props = {
  isDraft?: boolean
  status?: {
    name: string
    type: RecordTypeStatusType
    renewalStatus?: RecordRenewalStatus | null
  } | null
  isArchived?: boolean
}

const getColor = (
  type: RecordTypeStatusType,
  renewalStatus?: RecordRenewalStatus | null
): TagColor => {
  // Expired and Late Period renewal statuses always render red regardless of the underlying status type
  if (renewalStatus === 'Expired' || renewalStatus === 'LatePeriod') {
    return 'red'
  }

  switch (type) {
    case 'ToDo': {
      return 'blue'
    }
    case 'InProgress': {
      return 'yellow'
    }
    case 'Complete': {
      return 'green'
    }
    case 'CompleteNegative': {
      return 'red'
    }
  }
}

export const RecordTypeStatusDisplay = (props: Props) => {
  const { isDraft, status, isArchived } = props
  if (isDraft) {
    return <Tag color="default">Draft</Tag>
  }
  const name = status?.name
  const type = status?.type
  const color = type ? getColor(type, status?.renewalStatus) : 'default'
  return (
    <Tag color={color}>
      {name}
      {isArchived && ' (Archived)'}
    </Tag>
  )
}
